import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Card} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Card, {
            'title': '用户信息',
            'children': [
                _$ce(2, 'div', '卡片内容', 16),
                _$ce(2, 'div', '卡片内容', 16)
            ]
        }),
        _$cc(Card, {
            'title': '用户信息',
            'type': 'border',
            'children': [
                _$ce(2, 'div', '卡片内容', 16),
                _$ce(2, 'div', '卡片内容', 16)
            ]
        })
    ], 4);
};